export const NOVU_URL =
  process.env.REACT_APP_NOVU_URL ?? "https://novu.scieverinc.com";
export const NOVU_APP_IDENTIFIER =
  process.env.REACT_APP_NOVU_APP_IDENTIFIER ?? "imA23BZB3dtZ";
